import React, { useMemo } from 'react';
import { useSelector } from "react-redux";
import DiariesCell from './diariesCell';

const DiariesListingGroup = ({ data, onItemClick }) => {       
    const selectedDiary = useSelector(state => state.diaries.listing.selectedDiary);
    const dateClass = useMemo(() =>
        selectedDiary && data.data.some(d => d.todo_id === selectedDiary) ? 'dateActive' : '',
    [selectedDiary, data.data]);
    return (
        <div data-test="Diary Group" className="activity-listing detailListingGroup teamGroupDiary">
            <div className={`date ${dateClass}`}>
                <span>{data.created_date}</span>
            </div>
            <ul>
                {data.data.map(d => (
                    <DiariesCell key={d.todo_id} data={d} onItemClick={onItemClick} />
                ))}
            </ul>
        </div>
    );
};

export default DiariesListingGroup;